import { Component, OnInit, HostListener } from '@angular/core';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { PATHS } from '../../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';
import { Router, NavigationEnd } from '@angular/router';
import { ColorPalette } from '../../../../analytics-core/interfaces/partner.interface';
import * as jQuery from 'jquery';
@Component({
	selector: 'app-breadcrumb-drawer',
	templateUrl: './breadcrumb-drawer.component.html',
	styleUrls: ['./breadcrumb-drawer.component.css']
})
export class BreadcrumbDrawerComponent implements OnInit {
	public toggled: boolean = true;
	public imgSrcOpen: string;
	public imgSrcLock: string;
	public isOverview: any;
	public screenWidth: number;
	public enableLock: boolean;
	public toggleLeftPane: any;
	public handler;
	public colorPalette: ColorPalette;
	public openHandle: string;
	public closeHandle: string;
	constructor(protected analyticsDataModel: AnalyticsDataModel, private router: Router) {
		this.imgSrcOpen = 'assets/images/close-drawer.png';
		this.imgSrcLock = this.analyticsDataModel.config.handleLockIcon;
		this.openHandle = this.analyticsDataModel.config.openHandleIcon;
		this.closeHandle = this.analyticsDataModel.config.closeHandleIcon;
		this.screenWidth = window.innerWidth;
		this.toggleLeftPane = EmitterService.get(EVENT_EMITTERS.TOGGLE_LEFTPANE).subscribe((resp: any) => {
			if (resp) {
				document.getElementById('mask-on-rightsection').style.display = 'none';
				if (this.screenWidth < 1940) {
					this.toggled = true;
					this.toggle();
				} else if (this.screenWidth >= 1940) {
					this.toggled = false;
				}
			}
		});
		router.events.subscribe((val) => {
			if (val instanceof NavigationEnd) {
				if (val.url.includes('overview')) {
					this.isOverview = true;
					document.getElementById('right-section').style.marginLeft = '500px';
					document.getElementById('right-section').style.paddingLeft = '20px';
					document.getElementById('right-section').style.paddingRight = '20px';
					document.getElementById('mask-on-rightsection').style.display = 'none';
					this.toggled = false;
					this.toggle();
				} else if (!val.url.includes('overview')) {
					this.isOverview = false;
					document.getElementById('right-section').style.margin = 'auto';
					document.getElementById('right-section').style.paddingLeft = '100px';
					document.getElementById('right-section').style.paddingRight = '100px';
				}
			}
		});
	}

	ngOnInit(): void {
		if (!this.isOverview) {
			document.getElementById('mask-on-rightsection').style.display = 'none';
		}
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}
	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.screenWidth = window.innerWidth;
	}
	ngAfterContentChecked() {
		if (this.analyticsDataModel.getCurrentPath() === PATHS.OVERVIEW) {
			this.isOverview = true;
		} else {
			this.isOverview = false;
		}
		if (this.isOverview) {
			this.enableLock = true;
			document.getElementById('right-section').style.marginLeft = '500px';
			document.getElementById('right-section').style.paddingLeft = '20px';
			document.getElementById('right-section').style.paddingRight = '20px';
		} else {
			this.enableLock = this.screenWidth > 1939 ? true : false;
			if (this.screenWidth > 1939) {
				this.toggled = true;
				document.getElementById('mask-on-rightsection').style.display = this.toggled ? 'block' : 'none';
			}
			document.getElementById('mask-on-rightsection').style.display = this.toggled ? 'block' : 'none';
			if (this.enableLock) {
				document.getElementById('mask-on-rightsection').style.display = 'none';
				document.getElementById('left-menu').style.marginLeft = '0px';
				this.handler = document.getElementsByClassName('handle')[0] as HTMLElement;
				this.handler.style.marginLeft = '430px';
			}
		}
	}

	onMouseOver(): void {}
	onMouseOut(): void {
		this.imgSrcOpen = !this.toggled ? 'assets/images/open-drawer.svg' : 'assets/images/close-drawer.svg';
	}
	onMouseDown() {
		this.imgSrcOpen = !this.toggled
			? 'assets/images/open-drawer-clicked.png'
			: 'assets/images/close-drawer-clicked.png';
	}
	toggle() {
		document.getElementById('left-menu').style.marginLeft = this.toggled ? '-430px' : '0px';
		document.getElementById('mask-on-rightsection').style.display = 'none';
		if (!this.isOverview) {
			document.getElementById('left-section').style.width = '0';
			document.getElementById('mask-on-rightsection').style.display = this.toggled ? 'none' : 'block';
		}
		this.handler = document.getElementsByClassName('handle')[0] as HTMLElement;
		this.handler.style.marginLeft = this.toggled ? '0px' : '430px';
		this.handler.style.transition = 'all 0.4s ease';
		this.toggled = !this.toggled;
		this.imgSrcOpen = !this.toggled ? 'assets/images/open-drawer.png' : 'assets/images/close-drawer.png';
	}
}
